<template>
    <!--                <el-menu v-if="!isCollapse" :router="true" :default-active="activeLink"-->
    <!--                         class="el-menu-vertical-demo" :class="{'hide-menu-mobile':isCollapse}" :collapse="isCollapse">-->
    <div>
        <el-menu-item index="Dashboard" :route="{name:'Dashboard'}">
            <i class="el-icon-odometer" style="width:32px; height: 20px; color:#46A0FC"></i>
            <span slot="title">Dashboard</span>
        </el-menu-item>
        <el-submenu index="1">
            <template slot="title">
                <i class="el-icon-location"></i>
                <span slot="title">Taxi</span>
            </template>
            <el-menu-item index="Taxi">
                                <span slot="title">

                <i class="el-icon-phone" style="width:32px; height: 20px; color:#46A0FC"/>
                Call
                                </span>
            </el-menu-item>

            <el-menu-item index="Taxi">
                <span slot="title">
                <i class="el-icon-map-location"
                   style="width:32px; height: 20px; color:#46A0FC"
                />
                Map
                </span>
            </el-menu-item>
            <el-menu-item index="requests">
                                <span slot="title">

                Requests
                                </span>
            </el-menu-item>
        </el-submenu>
        <el-submenu index="2">
            <template slot="title">
                <i class="el-icon-location"></i>
                <span>Bus</span>
            </template>
            <el-menu-item index="Bus">Bus</el-menu-item>
            <el-menu-item index="add-bus-station">Add Station</el-menu-item>
        </el-submenu>

        <el-submenu index="3">
            <template slot="title">
                <i class="el-icon-location"></i>
                <span>Travel</span>
            </template>
            <el-menu-item index="Travel" :route="{name: 'Travel'}">Travel</el-menu-item>
            <el-menu-item index="TravelOffer" :route="{name: 'Add Travel Offer'}">Add Offer
            </el-menu-item>
            <el-menu-item index="TravelCompany" :route="{name: 'Add Travel Company'}">Add Company
            </el-menu-item>

        </el-submenu>

        <el-menu-item index="add-base">
            <i class="el-icon-odometer" style="width:32px; height: 20px; color:#46A0FC"></i>
            <span slot="title">Add Base</span>
        </el-menu-item>

        <el-menu-item index="add-city">
            <i class="el-icon-odometer" style="width:32px; height: 20px; color:#46A0FC"></i>
            <span slot="title">Add City</span>
        </el-menu-item>
        <el-menu-item index="feedback">
            <i class="el-icon-odometer" style="width:32px; height: 20px; color:#46A0FC"></i>
            <span slot="title">Feedback</span>
        </el-menu-item>

        <el-menu-item index="profile">
            <i class="el-icon-odometer" style="width:32px; height: 20px; color:#46A0FC"></i>
            <span slot="title">Profile</span>
        </el-menu-item>
    </div>
    <!--                </el-menu>-->
</template>
<script>
    export default {
        props: ['isCollapse', 'activeLink']
    }
</script>
<style lang="scss" scoped>
    .packageIcon {
        width: 32px;
        height: 20px;
        color: #46A0FC
    }

    .sidebar {
        border-right: 1px solid #e6e6e6;

        .el-menu {
            border-right: 0;
            text-align: left;
        }

        .el-menu-vertical-demo:not(.el-menu--collapse) {
            width: 220px;
        }

        .el-submenu-vertical-demo:not(.el-submenu--collapse) {
            width: 220px;
        }

        .el-submenu {
            border-right: 0px;
            text-align: left;
        }

        .collapsed {
            background-color: grey;
        }

        .el-menu-vertical-demo {
            height: 100vh;
        }

        .hotel-details {
            min-height: 60px;
            padding: 0 20px;
            border-bottom: 1px solid #e6e6e6;
            display: flex;
            align-items: center;

            @media screen and (max-width: 768px) {
                border-bottom: 1px solid #e6e6e6;
                display: flex;
                flex: 1;
            }

            .property-name-code {
                display: flex;
                flex-direction: column;
                margin-top: 6px;
                margin-left: 10px;

                @media (max-width: 768px) {
                    flex: 3;
                }
            }

            .property-icon {
                @media screen and (max-width: 768px) {
                    display: flex;
                    flex: 1;
                    justify-content: space-between;
                }

                .size-36 {
                    width: 36px;
                }

                .size-48 {
                    width: 48px;
                }
            }

            .hamburger {
                display: none;
                cursor: pointer;
                border: 1px solid #e6e6e6;
                border-radius: 4px;
                height: 40px;
                align-items: center;
                justify-content: center;
                width: 40px;

                @media screen and (max-width: 768px) {
                    display: flex;
                }

            }

            .hamburger:hover {
                background-color: #e6e6e6;
            }

        }
    }

    .content-wrapper {
        flex: 1;
        display: flex;

        .sidebar {

        }

        .content {
            /*padding-bottom: 10px;*/
            flex: 1;

            .box-card {
                margin-bottom: 10px;
            }
        }
    }
</style>
